import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Widget from '../../../components/Widget/Widget';
import Pictures from './Pictures/Pictures';
import WebSites from './WebSites/WebSites';
import Videos from './Videos/Videos';

import { loadStationSettings } from '../../../actions/settings';

import s from './CustomerScreen.module.scss';
import { withTranslation } from '../../../i18n/LanguageContext';

class CustomerScreen extends React.Component {

    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.dispatch(loadStationSettings());
    }

    render() {
        return (
            <div className={s.page}>
                <Widget className={s.layoutWidget}>
                    <div className={s.layoutGrid}>
                        <div className={s.layoutColumn}>
                            <Pictures />
                        </div>
                        <div className={s.layoutColumn}>
                            <WebSites />
                            <Videos />
                        </div>
                    </div>
                    <p className={s.infoNote}>
                        <strong>{this.props.t('customerScreen.note')}</strong> {this.props.t('customerScreen.noteBody')}
                    </p>
                </Widget>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        isReceiving: state.settings.isReceiving,
        isUpdating: state.settings.isUpdating,
        isDeleting: state.settings.isDeleting,
        idToDelete: state.settings.idToDelete,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(CustomerScreen)));
